import { constant } from "../constant";

export const getQuestionnaireAction = () => {
  return {
    type: constant.GET_QUESTIONNAIRE,
  };
};

